import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProductVariantsModal from "../../modals/ProductVariantsModal";
import { GlobalContext } from "../../Context/GlobalContext";
import { Check } from "lucide-react";
import { images } from "../../Assets/images";

const ProductCard = ({
  product,
  isChecked,
  onCheckboxChange,
  onShowVariant,
}) => {
  return (
    <div
      className={`card mb-0 overflow-hidden product-card ${isChecked ? "rp-card--selected" : ""}`}
      style={{ position: "relative", cursor: "pointer" }}
      onClick={() => onCheckboxChange(product)}
    >
      {/* ✅ Custom checkbox */}
      <div className={`rp-checkbox ${isChecked ? "rp-checkbox--checked" : ""}`}>
        <Check
          size={13}
          color={isChecked ? "#fff" : "transparent"}
          strokeWidth={3}
        />
      </div>

      <div className="rp-image">
        <img
          src={product.image}
          alt={product.short_desc}
          className="img-fluid"
          crossOrigin="anonymous"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = images.placeHolderImg;
          }}
        />
      </div>

      <div className="rp-body p-2 flex-grow-1 d-flex flex-column">
        <h6 className="mb-1 recommended-product-title fw-semibold">
          {product.short_desc}
        </h6>
        <p className="mb-2 recommended-product-description text-muted flex-grow-1">
          {product?.reasons?.length
            ? `Helps with ${product.reasons
                .slice(0, 3)
                .map((r) => r.name)
                .join(" & ")}`
            : "Recommended for you"}
        </p>
        {/* <div className="text-center">
          <Link
            className="text-primary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation(); // ✅ prevent card toggle
              onShowVariant(product);
            }}
          >
            Show Variant
          </Link>
        </div> */}
      </div>
    </div>
  );
};

const RecommendedProduct = () => {
  const { getRecProductList, fullProducts } = useContext(GlobalContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const scanID = queryParams.get("scanID");

  console.log(scanID, "scan in");

  const [modalProduct, setModalProduct] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleShowVariant = (product) => {
    setModalProduct(product);
    setModalOpen(true);
  };

  const handleCheckboxChange = (product) => {
    setSelectedProducts((prev) => {
      const isSelected = prev.some((p) => p.item_id === product.item_id);
      if (isSelected) {
        return prev.filter((p) => p.item_id !== product.item_id);
      } else {
        return [...prev, product];
      }
    });
  };

  const handleBuyNow = () => {
    if (selectedProducts.length === 0) {
      alert("Please select at least one product.");
      return;
    }
    selectedProducts.forEach((product) => {
      const url = `https://www.4life.com/us/en/product/${product.web_id}`;
      window.open(url, "_blank");
    });
  };

  useEffect(() => {
    getRecProductList(scanID);
  }, [scanID]);

  return (
    <div className="content-part">
      <div className="alert alert-success p-2" role="alert">
        Thank You for completing the Healthy 4Life Assessment.
      </div>

      <h5 className="mb-3">
        Based on your response, here are your Recommended Products
      </h5>

      <div className="row g-3 mb-3">
        {fullProducts?.fullList?.map((product, i) => (
          <div className="col-6 pt-0" key={product.item_id}>
            <ProductCard
              product={product}
              isChecked={selectedProducts.some(
                (p) => p.item_id === product.item_id,
              )}
              onCheckboxChange={handleCheckboxChange}
              onShowVariant={handleShowVariant}
            />
          </div>
        ))}
      </div>

      {/* Actions */}
      <div className="d-flex justify-content-end mt-4">
        <button
          className="btn btn-primary"
          disabled={selectedProducts.length === 0}
          onClick={handleBuyNow}
        >
          Continue
          {/* {selectedProducts.length > 0 && `(${selectedProducts.length})`} */}
        </button>
      </div>

      <ProductVariantsModal
        show={modalOpen}
        product={modalProduct}
        onClose={() => {
          setModalOpen(false);
          setModalProduct(null);
        }}
      />
    </div>
  );
};

export default RecommendedProduct;
